import { render, staticRenderFns } from "./Examstatistics.vue?vue&type=template&id=5dbc53e3"
import script from "./Examstatistics.vue?vue&type=script&lang=js"
export * from "./Examstatistics.vue?vue&type=script&lang=js"
import style0 from "./Examstatistics.vue?vue&type=style&index=0&id=5dbc53e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports